import css from './PieceDetailsPage.css';

export const getId = (entityId) => {
  if (!entityId) return null;
  if (typeof entityId === 'string') return entityId;
  return entityId.uuid || String(entityId);
};

export const makeKey = (type, id) => {
  const parsedId = getId(id);
  return parsedId ? `${type}:${parsedId}` : null;
};

export const formatStoreName = (provider) => {
  if (!provider) return null;
  const rawName = provider.secondaryName || provider.name || '';
  const cleanedName = rawName.replace(/^Decathlon\s*/i, '').trim();
  const dkCode = provider.dkCode;

  if (dkCode) {
    return `${dkCode} - ${cleanedName || rawName}`;
  }
  return cleanedName || rawName;
};

export const getStatusConfig = (status) => {
  const normalizedStatus = status ? status.toLowerCase() : 'unknown';

  switch (normalizedStatus) {
    case 'available':
      return { label: 'Dostępny', badgeClass: css.badgeAvailable };
    case 'rented':
    case 'rent':
      return { label: 'Wypożyczony', badgeClass: css.badgeRented };
    case 'service':
      return { label: 'Serwis', badgeClass: css.badgeService };
    case 'reserved':
    case 'internal-use':
      return { label: 'Rezerwacja', badgeClass: css.badgeReserved };
    default:
      return { label: status || 'Brak danych', badgeClass: css.badgeDefault };
  }
};